/**
 * main.tsx — the bundle entry: CSS, React root, service-worker registration.
 * esbuild bundles this to `web/dist/app.js` + `web/dist/app.css` (ARCHITECTURE §1).
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/tokens.css';
import './styles/theme.css';
import { App } from './app.tsx';

const container = document.getElementById('root');
if (container) {
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

// PWA shell (never /api) — registered after load so it never delays the first paint.
if ('serviceWorker' in navigator && location.protocol === 'https:') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* an unavailable service worker must never break the app */
    });
  });
}
